import { useState } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import CreateIcon from '@mui/icons-material/Create';
import CommentIcon from '@mui/icons-material/Comment';

import Activities from './Activities/Activities';
import Forum from './Forum/Forum';
import NotesContainer from './NotesContainer/NotesContainer';
import classes from './LessonRight.module.css';

const LessonRight = props => {
  const { t } = useTranslation(['lesson']);
  const dataLesson = useSelector(state => state.lessonInfo);
  const [value, setValue] = useState(1);

  const handleChange = (event, newValue) => {
    if (newValue === 3) {
      props.changeView(1);
    }
    setValue(newValue);
  };

  return (
    <div className={classes.lessonRightContainer}>
      <Tabs
        value={value}
        onChange={handleChange}
        TabIndicatorProps={{ style: { background: '#890f20' } }}
      >
        <Tab
          className={`${classes.tab} ${
            value === 1 && classes.itemSelected
          }`}
          value={1}
          icon={<FormatListBulletedIcon />}
          label={t('activities')}
        />
        <Tab
          className={
            !props.forumEnabled
              ? `${classes.tabNoShow}`
              : `${classes.tab} ${
                  value === 2 && classes.itemSelected
                }`
          }
          value={2}
          icon={<CommentIcon />}
          label={t('forum')}
        />
        <Tab
          className={`${classes.tab} ${
            value === 3 && classes.itemSelected
          }`}
          value={3}
          icon={<CreateIcon />}
          label={t('note')}
        />
      </Tabs>
      {value === 1 && (
        <Activities
          lessonData={dataLesson.data}
          material={dataLesson.files.rows}
          lessonProgress={dataLesson.lessonProgress}
          changeView={props.changeView}
          videoProgress={props.videoProgress}
          quizProgress={props.quizProgress}
          homeworkProgress={props.homeworkProgress}
          coevaluationProgress={props.coevaluationProgress}
        />
      )}
      {value === 2 && (
        <Forum idLesson={props.idLesson} idCourse={props.idCourse} />
      )}
      {value === 3 && (
        <NotesContainer
          view={props.view}
          idLesson={props.idLesson}
        />
      )}
    </div>
  );
};

LessonRight.propTypes = {
  // eslint-disable-next-line react/require-default-props
  lessonInfo: PropTypes.object,
  // eslint-disable-next-line react/require-default-props
  view: PropTypes.number,
  // eslint-disable-next-line react/require-default-props
  changeView: PropTypes.func,
  // eslint-disable-next-line react/require-default-props
  videoProgress: PropTypes.number,
  // eslint-disable-next-line react/require-default-props
  quizProgress: PropTypes.number,
  // eslint-disable-next-line react/require-default-props
  homeworkProgress: PropTypes.number,
  // eslint-disable-next-line react/require-default-props
  coevaluationProgress: PropTypes.number,
  // eslint-disable-next-line react/require-default-props
  forumEnabled: PropTypes.bool,
  // eslint-disable-next-line react/require-default-props
  idLesson: PropTypes.number,
  // eslint-disable-next-line react/require-default-props
  idCourse: PropTypes.number
};

export default LessonRight;
